import AuthSlice from "./auth";
import UI from "./ui";
import constantSlice from "./constant";
import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import { combineReducers } from "redux";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

const persistConfig = {
  key: "root",
  version: 1,
  storage: storage,
  //   blacklist: ["dashboard", "getKitchens"],
};

const sessionConfig = {
  key: "sessions",
  version: 1,
  storage: storageSession,
  blacklist: [],
};

const appReducer = combineReducers({
  getUI: UI,
  getAuth: AuthSlice,
});

const sessionReducer = combineReducers({
  getConstants: constantSlice,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const sessionStorageReducer = persistReducer(sessionConfig, sessionReducer);

export const store = configureStore({
  reducer: { persistedReducer, sessionStorageReducer },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export let persistor = persistStore(store);
